<button matIconButton aria-label="main menu button" (click)="toggle()">
  <mat-icon fontSet="material-symbols-outlined">apps</mat-icon>
</button>
